import { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/sections/About";
import NomNomSection from "@/components/sections/NomNomSection";
import Contact from "@/components/sections/Contact";

export default function Home() {
  useEffect(() => {
    document.title = "Nom Apps LLC — Makers of NomNom: AI Calorie Tracker";
  }, []);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <NomNomSection />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
